// This file is auto-generated during build
// Do not edit manually

export interface BuildInfo {
  gitHash: string;
  buildDate: string;
}

export const buildInfo: BuildInfo = {
  gitHash: '406677e',
  buildDate: '2026-05-29T10:15:12.710Z',
};
